const handleLangMenu = () => {
  const navWrapperSelector = '.menu-language-menu-container';
  const listSelector = '.nav-lang .nav .sub-menu';

  const navWrapperEl = document.querySelector(navWrapperSelector);
  const listEl = document.querySelector(listSelector);

  if (listEl !== null) {
    listEl.style.height = 'auto';
    const listHeight = listEl?.clientHeight;
    listEl.style.height = `${0}px`;

    if (listHeight) {
      navWrapperEl.addEventListener('mouseenter', () => {
        listEl.style.height = `${listHeight}px`;
      });
      navWrapperEl.addEventListener('mouseleave', () => {
        listEl.style.height = `${0}px`;
      });
    }
  }
};

export default handleLangMenu;
